const DATABASE = 'facilita-uploads';
const STORE = 'sessions';
const VERSION = 1;

const openDatabase = () => new Promise((resolve, reject) => {
    const request = window.indexedDB.open(DATABASE, VERSION);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE, { keyPath: 'sessionId' });
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
});

const inStore = async (mode, action) => {
    const database = await openDatabase();
    return new Promise((resolve, reject) => {
        const operation = action(database.transaction(STORE, mode).objectStore(STORE));
        operation.onsuccess = () => resolve(operation.result);
        operation.onerror = () => reject(operation.error);
    });
};

const safely = (work, fallback) => {
    if (!window.indexedDB) return Promise.resolve(fallback);
    return work().catch(() => fallback);
};

export const resumeStore = {
    save: (entry) => safely(() => inStore('readwrite', store => store.put(entry)), null),
    remove: (sessionId) => safely(() => inStore('readwrite', store => store.delete(sessionId)), null),
    all: () => safely(() => inStore('readonly', store => store.getAll()), []),
};
